module.exports = __webpack_public_path__ + "img/guideTwo.3edaf4ec.png";